<template>
  <div class="Steps-page">
    <div class="Steps-page-layout">
      <!-- 左侧三级菜单 -->
      <div class="Steps-page__menu" :class="{ 'is-collapsed': menuCollapsed }">
        <nested-menu
          :menu-list="subMenuListData"
          :active-key="activeMenuKey"
          :is-collapsed="menuCollapsed"
          @item-click="handleMenuClick"
          @toggle-collapse="handleToggleCollapse"
        />
      </div>
      <!-- 右侧内容区域 -->
      <div class="Steps-page__content">
        <module-container
          v-if="showHeader"
          :title="activeMenuName"
          :show-icon="false"
          :padding="false"
        >
        </module-container>
        <div class="page-content">
          <!-- 嵌套路由视图 -->
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NestedMenu from '@/components/nestedMenu'
import ModuleContainer from '@comp/moduleContainer'
import { mapGetters } from 'vuex'
export default {
  name: 'Steps',
  components: {
    NestedMenu,
    ModuleContainer
  },
  data() {
    return {
      activeMenuKey: 1,
      currentMenuKey: 1,
      // 菜单是否收起
      menuCollapsed: false,
      // 三级菜单数据
      subMenuList: [
        {
          id: 1,
          label: '整期推送',
          expanded: false,
          type: 1,
          colCode: 'new_zqts'
        },
        {
          id: 2,
          label: '专题推送',
          expanded: false,
          type: 2,
          colCode: 'new_ztts'
        },
        {
          id: 4,
          label: '单篇推送',
          expanded: false,
          type: 4,
          colCode: 'new_dpts'
        },
        {
          id: 3,
          label: '通知推送',
          expanded: false,
          type: 3,
          colCode: 'new_tzts'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isMedicalAssociationEnv', 'isCluster']),
    ...mapGetters('incrementService', ['getZdtsChildrenList']),
    activeMenuName() {
      let target = this.subMenuList.find(
        (item) => item.id === this.activeMenuKey
      )
      return target && target.label
    },
    activeMenuType() {
      let target = this.subMenuList.find(
        (item) => item.id === this.activeMenuKey
      )
      return target && target.type
    },
    showHeader() {
      let paths = this.$route.path
      let notShow = [
        '/steps/EmailTemplatePreview',
        '/newActivePushAnalysis',
        '/effectComparison'
      ]
      return !notShow.includes(paths)
    },
    // 最终显示在页面上的菜单
    subMenuListData() {
      let data = []
      if (this.isMedicalAssociationEnv) {
        data = this.subMenuList.filter((item) =>
          this.getZdtsChildrenList.some((it) => it.colCode === item.colCode)
        )
      } else {
        data = this.subMenuList
      }
      return data
    }
  },
  watch: {
    isCluster: {
      handler(nv) {
        // 集群并且是医学会显示主题推送
        if (nv && this.isMedicalAssociationEnv) {
          this.subMenuList.splice(2, 0, {
            id: 5,
            label: '主题推送',
            expanded: false,
            type: 5,
            colCode: 'new_stts'
          })
        }
      },
      immediate: true
    },
    subMenuListData: {
      handler(nv) {
        if (nv && nv.length) {
          if (nv.some((item) => item.type === Number(this.$route.query.type))) {
            this.activeMenuKey = Number(this.$route.query.type)
          } else {
            this.handleMenuClick(nv[0])
          }
        }
      },
      immediate: true
    }
  },
  created() {
    // 通知推送
    if (this.$route.query.type == 3) {
      this.$store.commit('incrementService/updataProgressPages', [
        { label: '邮件模板', route: '/steps/emailTemplate' },
        { label: '遴选学者', route: '/steps/selectScholars' },
        { label: '查看学者', route: '/steps/viewScholars' },
        { label: '推送测试', route: '/steps/pushTest' },
        { label: '正式推送', route: '/steps/officialPush' }
      ])
    } else {
      this.$store.commit('incrementService/updataProgressPages', [
        { label: '选取论文', route: '/steps/paperList' },
        { label: '邮件模板', route: '/steps/emailTemplate' },
        { label: '遴选学者', route: '/steps/selectScholars' },
        { label: '查看学者', route: '/steps/viewScholars' },
        { label: '推送测试', route: '/steps/pushTest' },
        { label: '正式推送', route: '/steps/officialPush' }
      ])
    }
    this.$store.dispatch(
      'incrementService/updataTaskInfo',
      this.$route.query.taskId
    )
  },
  methods: {
    handleToggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed
    },
    handleMenuClick(item) {
      this.$router.push({
        path: '/newActivePushEmail',
        query: {
          columnId: '10-2',
          type: item.type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.Steps-page {
  min-height: 100%;
  height: 100%;
  &-layout {
    display: flex;
    height: 100%;
  }
  &__menu {
    width: 120px;
    background-color: #fff;
    border-right: 1px solid #e4e7ed;
    overflow: hidden;
    flex-shrink: 0;
    transition: width 0.3s ease;
    &.is-collapsed {
      width: 60px;
    }
  }
  &__content {
    padding: 20px;
    background: #f5f7fd;
    flex: 1;
    height: calc(100% - 40px);
    overflow-y: auto;
  }
  &__header {
    h2 {
      font-size: 16px;
    }
  }
}
</style>
